export enum ETrafficSourceType {
  DIRECT = 'direct',
  EMAIL = 'email',
  REFERRAL = 'referral',
  ORGANIC_SEARCH = 'organic-search',
  ORGANIC_SOCIAL = 'organic-social',
  PAID_SOCIAL = 'paid-social',
  PAID_SEARCH = 'paid-search',
  SMS = 'sms',
}

export interface IFilterTrafficSource {
  value?: ETrafficSourceType[];
}
